//import axios from "axios";

import { GET_CATEGORIES, CATEGORIES_ERROR } from "./types";
import { firebase } from "../../firebase";

export const getCategories = () => async (dispatch) => {
  try {
    let db = firebase.firestore();
    let categories = [];
    await db
      .collection("types")
      .where("active", "==", true)
      .orderBy("position", "asc")
      .get()
      .then((querySnapshot1) => {
        querySnapshot1.docs.map((doc) => {
          return categories.push({ id: doc.id, data: doc.data() });
        });
      });

    dispatch({
      type: GET_CATEGORIES,
      payload: categories,
    });
  } catch (error) {
    dispatch({
      type: CATEGORIES_ERROR,
      payload: error.message,
    });
  }
};
